export default "__VITE_ASSET__74f39c22__"